export default __webpack_public_path__ + "static/media/Bloodmire Gauntlets.915e07eb.jpg";